import DueDates from '@/pages/Tasks/components/DueDates'
import TaskPeople from '@/pages/Tasks/components/TaskPeople'
import { type Person, type Task, titleFor } from '@/pages/Tasks/task'

// The review page's task sidebar: TaskDrawer's header — title, due line,
// the people strip with its pickers — minus the verbs, which live on the
// submission card. No market row: the page already sits inside the market.
export default function ReviewTaskCard({ task, people }: { task: Task; people: Person[] }) {
  // The description is the doer's to-do. A reviewer reading it bare takes it
  // as addressed to them, so it gets a line saying whose task it is.
  const reviewing = task.state === 'submitted_for_review' && task.can.approve
  const inCharge = (task.responsible?.users ?? []).map((u) => u.name).join(', ')

  return (
    <div
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
      className="min-w-0 flex-1 rounded-lg border p-5"
    >
      <h2 className="text-lg font-bold leading-snug tracking-tight text-foreground">{titleFor(task)}</h2>
      {!task.completed_at && <DueDates task={task} />}
      <TaskPeople task={task} people={people} />
      {task.description !== task.details && (
        <p className="mt-2.5 whitespace-pre-line text-[13px] leading-relaxed text-foreground">
          {reviewing && (
            <span className="block font-semibold">
              What {inCharge || 'the person in charge'} was asked to do:
            </span>
          )}
          {task.description}
        </p>
      )}
    </div>
  )
}
